import { useTranslation } from 'react-i18next';
import { changeLocale, SUPPORTED_LOCALES, type SupportedLocale } from '../i18n';

/** 語言顯示名（**唔准硬編碼喺 JSX**：一律經 i18n key） */
const LOCALE_LABEL_KEY: Record<SupportedLocale, string> = {
  'zh-HK': 'locale_zh_hk',
  'zh-CN': 'locale_zh_cn',
  en: 'locale_en',
};

/** 語言切換（三語；偏好存 localStorage，由 `src/i18n.ts` 管） */
export default function LanguageSwitcher() {
  const { t, i18n } = useTranslation();
  const current = (i18n.language as SupportedLocale) ?? 'zh-HK';

  return (
    <select
      value={current}
      onChange={(e) => changeLocale(e.target.value as SupportedLocale)}
      aria-label={t('language_label')}
      style={{
        background: 'var(--color-card)',
        color: 'var(--color-text)',
        border: '1px solid var(--color-divider)',
        borderRadius: 6,
        padding: '4px 6px',
        fontSize: 'var(--font-size-small)',
      }}
    >
      {SUPPORTED_LOCALES.map((l) => (
        <option key={l} value={l}>
          {t(LOCALE_LABEL_KEY[l])}
        </option>
      ))}
    </select>
  );
}
